
export const rewardsConfig = {
  contractMaxStarsPackage: 'Premium', // reference for Umbraco value
  packageMaxStarsPackage: 'Premium', // reference for Umbraco value
  tenure21YearsPlus: 20, // points even across principle package
  tenure16to20Years: 15, // points even across principle package
  tenure11to15Years: 19, // points even across principle package
  tenure6to10Years: 5, // points even across principle package
  tenure5YearsOrLess: 3, // points even across principle package
  debtWaiverInsurance: 5, // points even across principle package
  subscriptionWaiverInsurance: 5, // points even across principle package
  funeralInsurance: 5, // points even across principle package
  numberOfActiveDecoderInsurances: 5, // points even across principle package
  insuranceMaxStars: 20, // skip in view calculations, 'dw + sw + f + n'
  statCategories: { // Groupings of stat (calc/maxCalc) properties into viewable categories
    stayConnected: [
      'rewardsTenure'
    ],
    productUsage: [
      'debtWaiverInsurance',
      'decoderInsurance',
      'funeralInsurance',
      'subscriptionWaiverInsurance',
      'hasDisneyPlus',
      'hasDstvInternet',
      'hasShowmax',
      'indianAddOn',
      'xtraViewPVRAccess',
      'hasStreama',
      'hasExplora',
      'hasExploraUltra',
    ],
    watchTime: [],
    selfServiceUsage: [
      'debitOrder',
      'marketingOptIn',
      'usedDstvNow3Months',
      'noDormantDays3Months',
      'usedBoxOffice3Months',
      'contract',
      'connectedExplora3Months',
    ],
    other: [
    ]
  }
};
